import React, { Component, useState } from "react";
import firebase from "../../firebase";
import "./bedlist.css";
import { Link } from "react-router-dom";
import FormPrompt from "../DailogBoxes/formprompt";
import {
	TimePicker,
	DatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Service from "../../Service/firebase";
import ConfirmDialogBox from "../DailogBoxes/confirmdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import { useEffect } from "react";
const BedList = () => {
	const [availableBedArray, setAvailableBedArray] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [limit, setLimit] = useState(10);
	const [isCloseBtnAppear, setIsCloseBtnAppear] = useState(true);
	const [totalNumOfPatient, setTotalNumOfPatient] = useState(null);
	const [noMoredataText, setNoMoredataText] = useState("");

	const [bedTypes, setBedTypes] = useState(["Type-1", "Type-2"]);
	const [isBedAllotted, setIsBedAllotted] = useState(true);
	const [isSearching, setIsSearching] = useState(false);
	const [isSearchDataShow, setIsSearchDataShow] = useState(false);
	const [serachText, setSerachText] = useState("");
	const [selectedBedAllotmentId, setSelectedBedAllotmentId] = useState("");
	const [careTaker, setCareTaker] = useState("");
	const [bedType, setBedType] = useState("");
	const [bedNum, setBedNum] = useState("");
	const [usedbedId, setUsedbedId] = useState("");
	const [selectedPatientName, setSelectedPatientName] = useState("");
	const [selectedPatientID, setSelectedPatientID] = useState("");
	const [dischargetime, setDischargetime] = useState(new Date()); // `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`, const []= useState()
	const [dischargedate, setDischargedate] = useState(new Date()); //`${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`, const []= useState()

	const [isGoingToBeDischarge, setIsGoingToBeDischarge] = useState("");
	const [isDischarged, setIsDischarged] = useState(false);
	const [isadmitted, setIsadmitted] = useState(true);
	const [isPromptLoading, setIsPromptLoading] = useState(false);
	const [isLoadMoredata, setIsLoadMoredata] = useState(false);

	const [allotedbedlist, setAllotedbedlist] = useState([]);
	const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
	const [isDeleting, setIsDeleting] = useState(false);
	const [openErrorDailog, setOpenErrorDailog] = useState(false);
	const [openFormDailog, setOpenFormDailog] = useState(false);
	// console.log(allotedbedlist, "allotedbedlist");
	useEffect(() => {
		onSettotalNumOfPatients();
		onFetchData(limit);
	}, []);
	const showMore = () => {
		if (limit <= totalNumOfPatient) {
			const limits = limit + 10;
			console.log(totalNumOfPatient);
			setLimit(limits);
			onFetchData(limit);
		} else {
			setNoMoredataText("No more allotted patients");
		}
	};
	const onSettotalNumOfPatients = () => {
		const db = firebase.firestore();
		db.collection("beds")
			.get()
			.then((snapshot) => {
				setTotalNumOfPatient(snapshot.docs.length);
			})
			.catch((e) => {
				console.log(e);
			});
	};
	const onFetchData = async (limit) => {
		setIsLoadMoredata(true);
		const fetchedDataList = await Service.getData("beds", limit);

		if (fetchedDataList.length !== 0) {
			setAllotedbedlist(fetchedDataList);
			setIsLoadMoredata(false);
			setIsLoading(false);
		} else {
			setIsLoading(false);
			setIsLoadMoredata(false);
		}
	};

	const handleOnDelete = async () => {
		setIsDeleting(true);

		const res = await Service.deleteData("beds", selectedBedAllotmentId);

		if (res === "success") {
			const sendData = {
				bedallotementid: "",
				isBedAllotted: false,
			};
			const result = await Service.updateData(
				"patients",
				selectedPatientID,
				sendData
			);

			if (result === "success") {
				await Service.updateBed("availablebed", usedbedId, true);
				setIsDeleting(false);
				setOpenConfirmDailog(false);
				onFetchData();
			} else {
				setIsDeleting(false);
				setOpenConfirmDailog(false);
				setOpenErrorDailog(true);
			}
		}
	};
	const handleSeach = async () => {
		if (serachText === "" || null) {
			onFetchData();
		} else {
			setIsSearching(true);
			setIsSearchDataShow(true);

			const searchText = serachText.toLowerCase().replace(/\s/g, "");
			const resultPatientlist = await Service.getSearchRes("beds", searchText);
			if (resultPatientlist === "error") {
				setIsSearching(false);
				setOpenErrorDailog(true);
			} else {
				setAllotedbedlist(resultPatientlist);
				setIsSearching(false);
			}
		}
	};
	// console.log(usedbedId);
	const handleSubmit = async (event) => {
		const data = new FormData(event.target);
		setIsPromptLoading(true);
		setIsCloseBtnAppear(false);
		if (!isDischarged) {
			setDischargetime("");
			setDischargedate("");
		}
		const sendData = {
			allotedbednum: data.get("bedNum"),
			allotedbedtype: data.get("bedType"),
			caretaker: data.get("careTaker"),
			dischargetime: dischargetime,
			dischargedate: dischargedate,
			isDischarged: isDischarged,
			isadmitted: isadmitted,
			isBedAllotted: isBedAllotted,
		};
		const res = await Service.updateData(
			"beds",
			selectedBedAllotmentId,
			sendData
		);

		if (res === "success") {
			const sendData = {
				isBedAllotted: isBedAllotted,
			};
			const result = await Service.updateData(
				"patients",
				selectedPatientID,
				sendData
			);
			if (result === "success") {
				setIsPromptLoading(false);
				setIsCloseBtnAppear(false);
				setOpenFormDailog(false);

				onFetchData();
			} else {
				setIsPromptLoading(false);
				setOpenErrorDailog(true);
			}
		} else {
			setIsPromptLoading(false);
			setOpenErrorDailog(true);
		}
	};

	const isGoingToBeDischarged = (e) => {
		setIsDischarged(e.target.checked);
		if (e.target.checked) {
			setIsadmitted(false);
			setIsBedAllotted(false);
			setIsGoingToBeDischarge("");
			setDischargedate(new Date());
			setDischargetime(new Date());
		} else {
			setIsBedAllotted(true);
			setIsadmitted(true);
			setIsGoingToBeDischarge("false");
			setDischargedate(""); //  new Date(),
			setDischargetime(""); //</td>new Date(),
		}
	};
	const handleDateChange = (date) => {
		setDischargedate(date);
	};
	const handleTimeChange = (date) => {
		setDischargetime(date);
	};
	const closeConfirmDailog = () => {
		setOpenConfirmDailog(false);
	};
	const closeErrorDailog = () => {
		setOpenErrorDailog(false);
	};

	const handleErrorDailog = () => {
		setOpenFormDailog(false);
		setOpenConfirmDailog(false);
		setOpenErrorDailog(true);
	};
	const closeBtnAppear = () => {
		setIsCloseBtnAppear(false);
	};
	const closeFormDailog = () => {
		setOpenFormDailog(false);
	};

	let count = 0;
	return isLoading ? (
		<div className="bedlistpage">
			<i className="fas fa-spinner fa-pulse fa-2x"></i>
		</div>
	) : (
		<div className="bedlistpage">
			<div className="main_section">
				<div className="topheader">
					<ul>
						<li>
							<i
								className="fa fa-arrow-circle-o-right fa-2x"
								aria-hidden="true"
							></i>
						</li>
						<li>
							<h5>BedList</h5>
						</li>
					</ul>
				</div>
				<hr />
				<div className="top_section">
					<ConfirmDialogBox
						openDailog={openConfirmDailog}
						onSetOpenDailog={closeConfirmDailog}
						handleConfirmOkBtn={handleOnDelete}
						isLoading={isDeleting}
						title="Delete"
						des={
							"Are you sure to delete " + selectedPatientName + " " + "details"
						}
					></ConfirmDialogBox>
					<ErorrDialogBox
						openDailog={openErrorDailog}
						onSetOpenDailog={closeErrorDailog}
						title="Error"
						des="Someting went wrong. Try again"
					></ErorrDialogBox>
					<FormPrompt
						onSetOpenDailog={closeFormDailog}
						isCloseBtnAppear={isCloseBtnAppear}
						openDailog={openFormDailog}
						title={"Mr/Mrs: " + selectedPatientName}
					>
						{isPromptLoading ? (
							<i
								className="fas fa-spinner fa-pulse fa-2x"
								style={{ position: "relative", top: " 0%", left: "40%" }}
							></i>
						) : (
							<form onSubmit={handleSubmit}>
								<div className="form-row">
									<div className="col-md">
										<label htmlFor="validationDefault10">Care Taker</label>
										<input
											name="careTaker"
											className="form-control"
											value={careTaker}
											onChange={(e) => setCareTaker(e.target.name)}
										></input>
									</div>
								</div>
								<div style={{ height: "10px" }}></div>

								<div className="form-row">
									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault10">Bed Type</label>
										<select
											name="bedType"
											className="custom-select"
											value={bedType}
											onChange={(e) => setBedType(e.target.name)}
											required
										>
											{bedTypes.map((option) => {
												return <option key={Math.random()}>{option}</option>;
											})}
										</select>
									</div>
									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault11">Bed Number</label>
										<input
											className="form-control"
											value={bedNum}
											name="bedNum"
											disabled={true}
											onChange={(e) => setBedNum(e.target.value)}
										/>
									</div>
								</div>
								<div className="form-group">
									<div className="form-check">
										<input
											className="form-check-input"
											type="checkbox"
											value=""
											id="invalidCheck2"
											checked={isDischarged}
											onChange={() => isGoingToBeDischarge()}
										/>
										<label className="form-check-label" htmlFor="invalidCheck2">
											{"Discharge Mr/Mrs: " + selectedPatientName + "  "}
										</label>
									</div>
								</div>

								<div className="form-row">
									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault11">Discharge Date</label>
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<DatePicker
												style={{
													padding: "0px 10px",
													border: "1px solid rgb(197, 197, 197)",
												}}
												name="dischargedate"
												className="  form-control"
												InputProps={{
													disableUnderline: true,
												}}
												readOnly={() => isGoingToBeDischarged()}
												value={
													dischargedate === "" ? new Date() : dischargedate
												}
												onChange={() => handleDateChange()}
												autoComplete="off"
												format="MM/dd/yyyy"
											/>
										</MuiPickersUtilsProvider>
									</div>

									<div className="col-md-6 mb-3">
										<label htmlFor="validationDefault11">Discharge Time</label>
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<TimePicker
												style={{
													padding: "0px 10px",
													border: "1px solid rgb(197, 197, 197)",
												}}
												InputProps={{
													disableUnderline: true,
												}}
												name="dischargetime"
												className="  form-control"
												readOnly={() => isGoingToBeDischarged()}
												value={
													dischargetime === "" ? new Date() : dischargetime
												}
												onChange={() => handleTimeChange()}
												autoComplete="off"
											/>
										</MuiPickersUtilsProvider>
									</div>
								</div>
								<div
									className="btnsection"
									style={{
										display: "flex",
										justifyContent: "flex-end",
									}}
								>
									<button
										className="btn btn-success bg-edit"
										type="submit"
										style={{
											borderRadius: "10px",
											padding: "5px 10px",
											fontSize: "14px",
										}}
									>
										Ok
									</button>
								</div>
							</form>
						)}
					</FormPrompt>{" "}
					<div className="wrap">
						<ul>
							<li>
								<div className="search">
									<input
										type="text"
										className="searchTerm"
										placeholder="Search patient by full name"
										onKeyDown={(e) => {
											if (e.key === "Enter") {
												handleSeach();
											}
										}}
										onChange={(e) => setSerachText(e.target.value)}
									/>

									<button
										onClick={handleSeach}
										type="submit"
										className="searchButton"
									>
										<i className="fa fa-search"></i>
									</button>
								</div>
							</li>
							<li style={{ fontSize: "14px" }}> #</li>
							<li tyle={{ fontSize: "14px" }}>{allotedbedlist.length} </li>
						</ul>
					</div>
					<Link to="/bedlistt/bedallotment">
						<button type="button" className="btn btn-warning bg-add">
							+ Add Allotment
						</button>
					</Link>
				</div>
				<table className="table table-striped">
					<thead className="thead tablehead">
						<tr>
							<th scope="col">#</th>
							<th scope="col">Bed Number</th>
							<th scope="col">Type</th>
							<th scope="col">Patient Name</th>
							<th scope="col">Allotment Date</th>
							<th scope="col">Allotment Time</th>
							<th scope="col">Discharge Date</th>
							<th scope="col">Discharge Time</th>
							<th scope="col">Care Taker</th>
							<th scope="col">Option</th>
						</tr>
					</thead>
					{isSearching ? (
						<i className="fas fa-spinner fa-pulse fa-2x "></i>
					) : allotedbedlist.length === 0 ? (
						<tbody>
							<tr>
								<td>No Patient Found</td>
							</tr>
						</tbody>
					) : (
						<tbody className="tablebody">
							{allotedbedlist &&
								allotedbedlist.map((p) => {
									count++;

									let alloteddate = new Date(p.allotedbeddatetime.toDate());
									let dischargeDate = "";
									let dischargeTime = "";

									if (p.dischargedate !== "" && p.dischargetime !== "") {
										dischargeDate = new Date(p.dischargedate.toDate());
										dischargeTime = new Date(p.dischargetime.toDate());
									}

									return (
										<tr key={p.patientid}>
											<td className="align-middle">{count}</td>
											<td className="align-middle">{p.allotedbednum}</td>
											<td className="align-middle">{p.allotedbedtype}</td>
											<td className="align-middle">{p.patientname}</td>
											<td className="align-middle">
												{alloteddate.getDate()}/{alloteddate.getMonth() + 1}/
												{alloteddate.getFullYear()}
											</td>

											<td className="align-middle">
												{" "}
												{alloteddate.getHours()}:{alloteddate.getMinutes()}
											</td>

											<td className="align-middle">
												{p.dischargedate === ""
													? "N/A"
													: `${dischargeDate.getDate()}/${
															dischargeDate.getMonth() + 1
													  }/
                        ${dischargeDate.getFullYear()}`}
											</td>

											<td className="align-middle">
												{p.dischargetime === ""
													? "N/A"
													: `${dischargeTime.getHours()}:${dischargeTime.getMinutes()}`}
											</td>
											<td className="align-middle">
												{" "}
												{p.caretaker === "" ? "N/A" : p.caretaker}
											</td>

											<td className="align-middle">
												<button
													type="button"
													className="btn btn-success bg-edit"
													onClick={() => {
														setOpenFormDailog(true);
														setSelectedBedAllotmentId(p.bedallotementid);
														setSelectedPatientName(p.patientname);
														setIsDischarged(p.isDischarged);

														setBedType(p.allotedbedtype);
														setBedNum(p.allotedbednum);
														setCareTaker(p.caretaker);
														setSelectedPatientID(p.patientid);

														if (p.dischargetime === "") {
															setIsGoingToBeDischarge("false");
															setDischargedate(""); //  new Date(),
															setDischargetime(""); //new Date(),
														} else {
															setIsGoingToBeDischarge("");
															setDischargedate(p.dischargedate.toDate());
															setDischargetime(p.dischargetime.toDate());
														}
													}}
												>
													<i className="fa fa-edit" aria-hidden="true"></i>
												</button>

												<button
													type="button"
													className="btn btn-danger bg-delete"
													onClick={() => {
														setOpenConfirmDailog(true);
														setSelectedBedAllotmentId(p.bedallotementid);
														setSelectedPatientID(p.patientid);
														setUsedbedId(p.usedbedId);
													}}
												>
													<i className="fa fa-trash" aria-hidden="true"></i>
												</button>
											</td>
										</tr>
									);
								})}
						</tbody>
					)}
				</table>
				<div className="loadmoredatasection">
					{isLoadMoredata ? (
						<i className="fas fa-spinner fa-pulse fa-2x loadmoredataspinner"></i>
					) : (
						<div className="nomoredatatext">{noMoredataText}</div>
					)}
					{allotedbedlist.length === 0 ? null : isSearchDataShow ? null : (
						<button
							type="button"
							className="btn btn-warning bg-add"
							onClick={() => showMore()}
						>
							Show More
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default BedList;
